/**
 * The `CareAtHome` claim has been removed for now because it currently not used
 */
export enum ClaimResponseTypeCode {
  HospitalAtHome = 'claimresponse.type.hospitalathome',
  TCP = 'claimresponse.type.tcp',
  RemotePatientMonitoring = 'claimresponse.type.remotepatientmonitoring',
  HealingHands = 'claimresponse.type.healinghands',
  Arthroplasty = 'claimresponse.type.arthroplasty',
  InHospitalMonitoring = 'claimresponse.type.inhospitalmonitoring',
  Lace = 'claimresponse.type.lace',
  HospitalAtHomeUpgrade = 'claimresponse.type.hospitalathome.upgrade',
  SPHERE = 'claimresponse.type.sphere',
}

export enum ClaimResponseTotalCategory {
  TotalClaimedAmount = 'claimresponse.total.category.totalclaimedamount',
  TotalPaidProviderAmount = 'claimresponse.total.category.totalpaidprovideramount',
  BalanceOutstandingAmount = 'claimresponse.total.category.balanceoutstandingamount',
}

export enum ClaimResponseItemAdjudicationCategory {
  BilledAmount = 'claimresponse.item.adjudication.category.billedamount',
  MedicalAidPayable = 'claimresponse.item.adjudication.category.medicalaidpayable',
  MedicalAidRate = 'claimresponse.item.adjudication.category.medicalaidrate',
}
